// NOTE filemanagement Url
// export const fileUrl = "https://vulcan.houseofdev.tech/file-management-system/api";
export const fileUrl = "https://api.cmacc.in.th/file-management/api";
export default fileUrl;
